<template>
  <div class="teach-data">
    <div class="data-wrap">
      <div
        class="data-card"
        v-for="({ name, num, target_url }, i) in teachData"
        :key="i"
      >
        <a target="_blank" :href="target_url">
          <div class="content">
            <div class="count">{{ num }}</div>
            <div class="text">{{ name }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    menu: Object
  },
  created() {
    this.getTeachData();
  },
  data() {
    return {
      teachData: {},
    };
  },
  methods: {
    async getTeachData() {
      const teachData = await this.$http.getTeachData({ num: this.menu.num });
      this.teachData = teachData;
      console.log('数据模块', teachData);
    },
  },
  computed: {
    dataList() {
      return [
        {
          title: "本科专业",
          // count: this.teachData.undergraduateMajor,
          count: 59,
          link: 'http://ugs.hrbeu.edu.cn/2819/list.htm',
          icon: "iconbenkezhuanye",
        },
        {
          title: "一流专业",
          // count: this.teachData.firstMajor,
          count: 11,
          link: 'http://xxgk.hrbeu.edu.cn/_upload/article/files/5c/c0/721a4e0445c3ba3caf384e0f0283/81a77e10-a47c-4840-a5cd-f93471ecc688.pdf',
          icon: "iconzhuanrenjiaoshi",
        },
        {
          title: "专任教师",
          // count: this.teachData.fullTimeTeacher,
          count: 1057,
          link: 'http://www.hrbeu.edu.cn/szdw/szjs.aspx',
          icon: "iconzhuanrenjiaoshi",
        },
        {
          title: "教学名师",
          // count: this.teachData.famousTeachers,
          count: 26,
          link: 'http://www.hrbeu.edu.cn/szdw/jxms.aspx',
          icon: "iconjiaoxuemingshi",
        }
      ];
    },
  },
};
</script>

<style scoped lang='scss'>
.teach-data {
  height: 200px;
  background: url(../../../assets/images/home/daat_bg.png) no-repeat;
  background-size: cover;
  .data-wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .data-card {
      flex: 25%;
      padding-top: 55px;
      a {
        color: #fff;
      }
      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .count {
          // width: 224px;
          height: 47px;
          font-size: 40px;
          font-family: DINAlternate;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 47px;
          letter-spacing: 2px;
        }
        .text {
          margin-top: 6px;
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 28px;
          letter-spacing: 1px;
        }
      }
    }
  }
}

</style>